/**
 * Normalises an unknown thrown value to an Error instance.
 * Used by hooks that catch fetch or media errors.
 */
export const toError = (err: unknown): Error => {
	if (err instanceof Error) {
		return err;
	}
	return new Error(typeof err === 'string' ? err : 'Unknown error');
};
